import { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import SupportChat from './SupportChat';
import './OnboardingSupportChat.css';

export default function OnboardingSupportChat() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {!open && (
        <button
          type="button"
          className="onboarding-support-chat__launcher"
          onClick={() => setOpen(true)}
          aria-label="Open support chat"
        >
          <MessageCircle size={18} />
          <span>Support</span>
        </button>
      )}
      {open && (
        <SupportChat
          placement="floating"
          bottomOffset={96}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
}
